import { render, staticRenderFns } from "./rotation.vue?vue&type=template&id=2d7ffa5d&scoped=true&"
import script from "./rotation.vue?vue&type=script&lang=js&"
export * from "./rotation.vue?vue&type=script&lang=js&"
import style0 from "./rotation.vue?vue&type=style&index=0&id=2d7ffa5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ffa5d",
  null
  
)

export default component.exports